module.exports = __webpack_public_path__ + "static/img/020 4.0d98cc88.jpg";